import type { LanguageCode } from "../languages/language-codes";
import { Mark } from "@tiptap/react";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    language: {
      setLanguage: (code: LanguageCode) => ReturnType;
      unsetLanguage: () => ReturnType;
    };
  }
}

export type LanguageAttributes = {
  code?: LanguageCode;
};

export const Language = Mark.create<undefined, undefined>({
  name: "language",

  // Ensure our mark is not split up by decoration marks (e.g., bold, italic, color)
  priority: 110,

  addAttributes() {
    return {
      code: {
        parseHTML: (element) => element.getAttribute("lang"),
        renderHTML: (attributes: LanguageAttributes) => {
          return {
            lang: attributes.code,
            class:
              "bg-gray-50 border border-gray-200 rounded-md before:content-[attr(lang)] before:uppercase before:border-r before:border-gray-200 before:px-1 before:mr-1 before:text-black before:text-nowrap before:font-bold",
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "bdi[lang]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["bdi", HTMLAttributes, 0];
  },

  addCommands() {
    return {
      setLanguage:
        (code) =>
        ({ commands }) => {
          return commands.setMark(this.name, { code });
        },
      unsetLanguage:
        () =>
        ({ commands }) => {
          return commands.unsetMark(this.name);
        },
    };
  },
});
